import { render, staticRenderFns } from "./OnboardingCard.vue?vue&type=template&id=5c655ba0&"
import script from "./OnboardingCard.vue?vue&type=script&lang=js&"
export * from "./OnboardingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports